import React from 'react'
import { Loader } from './loader'
import { Thumbnail } from './thumbnail'

export function RecommendedList({
  itemsList,
  isInitialized,
  analyticsEventAction,
  analyticsEventCategory,
  analyticsEventLabel,
  analyticsEventValue,
}) {
  return (
    <ul className="recommended-list">
      {itemsList.map((item, idx) => (
        <li className="recommended-list__item" key={`recommended-list-${idx}`}>
          <a
            href={item.hlink}
            className="wrap-link"
            data-analytics-event-category={analyticsEventCategory}
            data-analytics-event-action={analyticsEventAction}
            data-analytics-event-label={analyticsEventLabel}
            data-analytics-event-value={`${analyticsEventValue} ${idx}`}
          >
            <Thumbnail imageUrl={item.image} title={item.title} />
          </a>
          <Loader isInitialized={isInitialized} />
        </li>
      ))}
    </ul>
  )
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/recommendedVideos/components/recommendedList.js